<template>
  <div
    v-if="!toggle"
    :class="confirmed ? 'mod--sucess' : 'mod--fail'"
    class="label__status LKRoadmapsFeedLabelConfirm"
  >
    <span
      class="text-sm-bold mod--roadmap-label"
      v-text="confirmedLabel"
    />
  </div>

  <div
    v-else
    :class="confirmed ? 'mod--sucess' : 'mod--fail'"
    class="label__status-active LKRoadmapsFeedLabelConfirm"
    @click="isActive = !isActive"
  >
    <div class="label-active-up">
      <div
        class="text-sm-bold mod--roadmap-label"
        v-text="confirmedLabel"
      />

      <div class="label-active-arrow">
        <IconToggle
          :active="isActive"
          :loading="isLoading"
          class="LKRoadmapsFeedLabelConfirm__icon-toggle"
        />
      </div>
    </div>

    <div
      :class="{ 'is-active': isActive }"
      class="label-active-down LKRoadmapsFeedLabelConfirm__bottom"
      @click.stop
    >
      <a
        href="#"
        class="text-sm-bold mod--label-option"
        @click.prevent="onChange"
        v-text="getLabel(!confirmed)"
      />
    </div>
  </div>
</template>

<script>
import IconToggle from '@/components/lk/icons/LKIconToggle.vue'


export default {
  name: 'LKRoadmapsFeedLabelConfirm',
  components: {
    IconToggle,
  },
  props: {
    toggle: Boolean,
    confirmed: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isActive: false,
    isLoading: false,
  }),
  computed: {
    confirmedLabel() {
      return this.getLabel(this.confirmed)
    },
  },
  watch: {
    isActive(value) {
      if (value) {
        setTimeout(() => {
          document.addEventListener('click', this.close)
        })
      } else {
        document.removeEventListener('click', this.close)
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener('click', this.close)
  },
  methods: {
    onChange() {
      this.close()
      this.$emit('change', this.toggleLoading)
    },
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
    close() {
      this.isActive = false
    },
    getLabel(confirmed) {
      return confirmed
        ? 'Подтверждено'
        : 'Не подтверждено'
    },
  },
}
</script>

<style lang="scss">

.LKRoadmapsFeedLabelConfirm {
  & &__icon-toggle {
    margin: 0;
    color: $webflow-color-white;
  }

  & &__bottom {
    height: 0;
    min-height: 0;
    opacity: 0;
    transition: all 0.2s;

    &.is-active {
      height: auto;
      opacity: 1;
    }
  }
}
</style>
